import { useSourcingInternalStore } from 'modules/sourcing-internal/stores/hooks';
import { useShallow } from 'zustand/react/shallow';
import { SourcingSharedSetupApplicationStep } from 'modules/sourcing-shared/shared-steps';
import { getSourcingInternalHeaderBreadcrumbs } from 'modules/sourcing-internal/utils';
import { Channels } from '../../../generated-graphql/types';

export const SourcingInternalSetupApplicationStep = () => {
  const {
    candidateBatch,
    applicationFormData,
    channelFormData,
    onSetupApplicationBack,
    onSetupApplicationNext,
    setStep
  } = useSourcingInternalStore(
    useShallow((state) => ({
      candidateBatch: state.candidateBatch,
      applicationFormData: state.applicationFormData,
      channelFormData: state.channelFormData,
      onSetupApplicationBack: state.onSetupApplicationBack,
      onSetupApplicationNext: state.onSetupApplicationNext,
      setStep: state.setStep
    }))
  );

  // This shouldn't happen
  if (!candidateBatch) return null;

  return (
    <SourcingSharedSetupApplicationStep
      headerBreadcrumbs={getSourcingInternalHeaderBreadcrumbs({
        candidateBatchJobTitle:
          candidateBatch.jobDescriptionParsed?.jobTitle ?? '',
        candidateBatchId: candidateBatch.id,
        setStep
      })}
      candidateBatchId={candidateBatch.id}
      hasCandidateBatchAtsJobId={!!candidateBatch.atsJobId}
      candidateBatchAtsJobPostingUrl={candidateBatch.atsJobPostingUrl}
      candidateBatchCustomJobPostingUrl={candidateBatch.customJobPostingUrl}
      defaultFormData={applicationFormData}
      channelType={channelFormData?.channel ?? Channels.Email}
      onSetupApplicationBack={onSetupApplicationBack}
      onSetupApplicationNext={onSetupApplicationNext}
    />
  );
};
